import { Collision } from '@dnd-kit/core';
import { SnackbarVariant } from '@eas/common-web';
import {
  CalendarHandle,
  CalendarSettingsType,
} from '@modules/planner/calendar/calendar-types';
import { GPSPoint, WorkOrder } from '@models';
import { getPlannedFrom } from '../utils/get-planned-from';
import { moveWorkOrder } from '../utils/move-poz-work-order';

type Props = {
  showSnackbar: (message: string, variant: SnackbarVariant) => void;
  workOrders: WorkOrder[];
  calendarRef: React.RefObject<CalendarHandle>;
  collision: Collision;
  calendarSettings: CalendarSettingsType;
  nextWorkOrder?: WorkOrder;
  prevWorkOrder?: WorkOrder;
  unitStartingPoint: GPSPoint;
};

export const handleMoveWorkOrder = async ({
  showSnackbar,
  workOrders,
  calendarRef,
  collision,
  calendarSettings,
  nextWorkOrder,
  prevWorkOrder,
  unitStartingPoint,
}: Props) => {
  if (workOrders.length > 1) {
    showSnackbar(
      'Nie je možné posunúť viaceré pracovné príkazy v stave POZ. \n Prosím označte iba jeden pracovný príkaz v stave POZ.',
      SnackbarVariant.ERROR
    );
    return;
  }

  const currentDate = calendarRef.current?.currentDate ?? 0;

  const collisionValue = collision?.data?.value ?? 0;
  const plannedFrom = getPlannedFrom(
    currentDate,
    collisionValue,
    calendarSettings,
    0
  );

  const resp = await moveWorkOrder({
    workOrder: workOrders[0],
    newStart: plannedFrom,
    unitStartingPoint,
    nextWorkOrder,
    prevWorkOrder,
  });
  if (!resp.ok) {
    showSnackbar(`Chyba: ${resp.error}`, SnackbarVariant.ERROR);
    return false;
  }
  return true;
};
